import React, { useState, useEffect, useRef } from 'react';
import { Button, Input, Alert, Form } from '@intech/web-ui';

import { FaArrowRight, FaEye, FaEyeSlash } from 'react-icons/fa';
import { FuncionarioService, UsuarioService } from '../../../services';
import { LoginEntidade } from '../../../entidades';
import { useHistory } from 'react-router-dom';
import { BaseAuth } from '../Base';
import { DMN_ORIGEM_SISTEMA } from '@domains';

export const PrimeiroAcesso: React.FC = () => {
  const history = useHistory();
  const form = useRef<Form>(null);

  const [UserName, setUserName] = useState<string>("");
  const [NewPassword, setNewPassword] = useState<string>("");
  const [ConfirmPassword, setConfirmPassword] = useState<string>("");
  const [senhaVisivel, setSenhaVisivel] = useState(false);
  const [senhaNovaVisivel, setSenhaNovaVisivel] = useState(false);
  const [AlertText, setAlertText] = useState<string>("");

  useEffect(() => {
    (async () => {
      const dados = await FuncionarioService.Buscar();
      const UserName = dados.DadosPessoais.NOME_ENTID;
      setUserName(UserName);
    })();
  }, []);

  async function trocarSenha() {
    try {
      setAlertText("");
      if (form.current?.validate()) {
        // Valida se a nova senha tem 6 ou mais caracteres.
        if (NewPassword.length < 6)
          setAlertText("A senha deve conter pelo menos 6 caracteres, um número (0-9), uma letra minúscula e maiúscula (a-z, A-Z) e um caracter especial.");

        // Valida se os campos de nova senha e confirmação são iguais.
        if (NewPassword !== ConfirmPassword)
          setAlertText("As senhas não coincidem.");

        const user = new LoginEntidade();
        user.SenhaNova = NewPassword;
        user.ConfirmarSenha = ConfirmPassword;
        user.Origem = DMN_ORIGEM_SISTEMA.PORTAL;

        await UsuarioService.AlterarSenhaPrimeiroAcesso(user);
        window.alert("Senha alterada com sucesso!");
        history.push("login");
      }
    }
    catch (e) {
      const error = e.response ? e.response.data : e;
      setAlertText(error);
      window.alert(error);
    }
  }

  return (
    <BaseAuth tamanho={550}>
      <Form ref={form}>
        <p style={{ textAlign: "justify" }}>
          {"Olá, "}
          <b>
            {UserName}
          </b>
          {","}
          <br />
          <br />
          {"Seja bem-vindo!"}
          <br />
          <br />
          {"Esse é o seu primeiro acesso ao novo Portal da FAELCE! Como você recebeu uma nova senha gerada automaticamente, ou acessou utilizando a sua senha do portal antigo, será necessário que você crie uma nova senha."}
          <br />
          <br />
        </p>

        <Alert type={"danger"}>
          {"A senha deve conter pelo menos 6 caracteres e um número (0-9)."}
        </Alert>

        <Input
          value={NewPassword}
          onChange={setNewPassword}
          title={"Nova Senha"}
          labelSize={4}
          required
          group
          type={senhaVisivel ? "text" : "password"}
          icon={senhaVisivel ? <FaEyeSlash /> : <FaEye />}
          buttonLeft={false}
          onButtonClick={() => setSenhaVisivel((old) => !old)}
        />

        <Input
          value={ConfirmPassword}
          onChange={setConfirmPassword}
          title={"Confirme Nova Senha"}
          labelSize={4}
          required
          group
          type={senhaNovaVisivel ? "text" : "password"}
          icon={senhaNovaVisivel ? <FaEyeSlash /> : <FaEye />}
          buttonLeft={false}
          onButtonClick={() => setSenhaNovaVisivel((old) => !old)}
        />

        <Alert type={'danger'} formAlert />
        {AlertText !== "" && <Alert type={"danger"}>
          {AlertText}
        </Alert>}

        <Button
          icon={<FaArrowRight />}
          type="primary"
          onClick={trocarSenha}
          title={"Continuar"}
          loadingText={"Enviando..."}
          usesLoading
          block
        />

      </Form>
    </BaseAuth>
  );
}